import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { first, map } from 'rxjs';
import { AbstractAuthService } from '../services';

@Pipe({
  name: 'watchFreeTrial',
})
export class WatchFreeTrialPipe implements PipeTransform, OnDestroy {
  private readonly asyncPipe: AsyncPipe;
  constructor(public readonly abstractAuthService: AbstractAuthService, private readonly cdr: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(this.cdr);
  }

  public transform(translateKey: string, loggedOutTranslateKey?: string): string {
    return this.asyncPipe.transform(
      this.abstractAuthService.isLoggedIn$.pipe(
        first(),
        map((isUserLoggedIn) => {
          if (!isUserLoggedIn) {
            return loggedOutTranslateKey || 'General_Watch_Free_Trial_Btn';
          }
          return translateKey;
        })
      )
    );
  }

  public ngOnDestroy() {
    this.asyncPipe.ngOnDestroy();
  }
}
